var map = {
	"./symbol_0.png": "e217",
	"./symbol_1.png": "0531",
	"./symbol_2.png": "857a",
	"./symbol_3.png": "4c6e",
	"./symbol_4.png": "8502",
	"./symbol_5.png": "565c",
	"./symbol_6.png": "194c",
	"./symbol_7.png": "f835",
	"./symbol_8.png": "e236",
	"./symbol_9.png": "595c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d6c2";